// AUTO-GENERATED by scripts/build/generate-blog-content.js — do not edit.
export const blogManifestLoaders = {
  fi: () => import(/* webpackChunkName: "blog-manifest-fi" */ './fi/index.json'),
  ru: () => import(/* webpackChunkName: "blog-manifest-ru" */ './ru/index.json'),
  en: () => import(/* webpackChunkName: "blog-manifest-en" */ './en/index.json'),
};
